import { Diagnostic } from './logDiagnostic';

/**
 * Replaces the app with the list of missing configuration values. Plain DOM on purpose: it must
 * render even though the app itself was never mounted.
 */
export function renderConfigErrorScreen(
  mountNode: HTMLElement,
  problems: readonly Diagnostic[],
): void {
  const container = document.createElement('div');
  container.setAttribute('data-testid', 'config-error-screen');
  container.style.cssText = [
    'font-family: "IBM Plex Sans", Arial, sans-serif',
    'max-width: 760px',
    'margin: 64px auto',
    'padding: 0 24px',
    'color: #1c1c1c',
    'line-height: 1.5',
  ].join(';');

  const heading = document.createElement('h1');
  heading.textContent = 'Anova cannot start: configuration is incomplete';
  heading.style.cssText = 'font-size: 24px; margin-bottom: 8px';

  const intro = document.createElement('p');
  intro.textContent =
    'The app was served without the environment values it needs, so it was not started. Fix the values below and reload.';

  const list = document.createElement('ul');
  list.style.cssText = 'padding-left: 20px';

  problems.forEach((problem) => {
    const item = document.createElement('li');
    item.style.cssText = 'margin-bottom: 16px';

    const title = document.createElement('strong');
    title.textContent = problem.title;
    item.appendChild(title);

    const fixes = document.createElement('ul');
    problem.fix.forEach((hint) => {
      const fix = document.createElement('li');
      fix.textContent = hint;
      fixes.appendChild(fix);
    });
    item.appendChild(fixes);

    list.appendChild(item);
  });

  const footer = document.createElement('p');
  footer.textContent =
    'The browser console holds the same list, also available as anovaDiagnostics.print().';
  footer.style.cssText = 'color: #6b6b6b';

  container.append(heading, intro, list, footer);

  mountNode.innerHTML = '';
  mountNode.appendChild(container);
}
